export const dashboardInfoIconDataHook = 'dashboard-info-icon';
